import initSlider from '../libs/initSlider';

document.addEventListener('DOMContentLoaded', (e) => {
  const latestMediaSlider = initSlider('[data-media-slider]', latestMediaSliderOptions);
  const latestPublicationsSlider = initSlider('[data-news-slider]', latestPublicationsSliderOptions);
});

const latestMediaSliderOptions = {
  slidesPerView: 2,
  spaceBetween: 24,
  watchSlidesProgress: true,

  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },

  breakpoints: {
    1281: {
      slidesPerView: 6,
    },
    769: {
      slidesPerView: 5,
    },
    601: {
      slidesPerView: 4,
    },
  },
};

const latestPublicationsSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 24,
  watchSlidesProgress: true,

  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },

  breakpoints: {
    1025: {
      slidesPerView: 4,
    },
    769: {
      slidesPerView: 3,
    },
    601: {
      slidesPerView: 2,
    },
  },
};
